import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loading } from '@/components/ui/Loading';
import { useAuthStore } from '@/stores/authStore';

export function ProtectedRoute() {
  const { user, adminProfile, isLoading, isInitialized } = useAuthStore();
  const location = useLocation();

  if (!isInitialized || isLoading) {
    return <Loading fullScreen message="認証を確認しています..." />;
  }

  if (!user || !adminProfile) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}

